export default {
  init() {
    const self = this;
    const sections = document.querySelectorAll('.iv-wp');

    // On load show elements currently in viewport
    this.elementsInView(sections);

    // On scroll check any new elements coming into viewport
    window.onscroll = function() {
      self.elementsInView(sections);
    };

    $(window).on('load', () => {
      self.elementsInView(sections);
    });

  },
  elementsInView(sections) {
    // @ref: https://blog.adriaan.io/check-if-elements-are-in-viewport-in-vanilla-javascript.html
    let i;
    let self = this;

    // Don't run the rest of the code if every section is already visible
    if (document.querySelectorAll('.iv-wp:not(.el-iv)').length === 0) return;

    // Run this code for every section in sections
    for (i = 0; i < sections.length; ++i) {
      if (sections[i].getBoundingClientRect().top <= window.innerHeight * 0.85 && sections[i].getBoundingClientRect().top > 0) {
        sections[i].classList.add('el-iv');
      }
    }
  },
};
